<template>
<div>

   
  
    <alert-box class="mt-1" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

    <div class="table-wrapper-scroll-y my-custom-scrollbar mt-1">
  
    <table class="table table-hover table-striped mb-0">
    <thead >
      <tr class="table-primary">
        <th scope="col"></th>
        <th scope="col">#</th>
        <th scope="col">ID PRODOTTO</th>
        <th scope="col">BRAND</th>
        <th scope="col">LINEA</th>
        <th scope="col">CODICE</th>
        <th scope="col">CATEGORIA</th>                
        <th scope="col">REPARTO</th>
        <th scope="col">STAGIONE</th>
        <th class="text-right" scope="col">PREZZO DI LISTINO</th>
        <th scope="col">PREZZO PROMO </th>
        <th scope="col">SCONTO PROMO </th>
        <th scope="col">COLORE(i)</th> 
        <th scope="col">SCONTO</th>       
        <th scope="col">PREZZO</th>       
      </tr>
    </thead>
    <tbody>
      
      <tr class="pointer" v-for="(item, index) in filteredItems" :key="index">
        
        <td>
           <input :disabled="true"  class="pointer" type="checkbox"  v-model.number="item.selected">           
        </td> 
        <td>{{index+1}}</td>
        <td>{{item.productId}}</td>
        <td>{{item.brand}}</td>
        <td>{{item.line}}</td>
        <td>{{item.sku}}</td>
        <td>{{item.category}}</td>        
        
        <td>{{item.department}}</td>
        <td>{{item.season}}-{{item.season_year}} </td>
        <td class="text-right">{{fmt1(item.price)}} </td>
         
        <td>{{item.promoPrice}}</td>
        <td>{{item.promoDiscount}}</td>
        <td>{{item.colorList}}</td>
        <td>{{item.promo_discount}}</td>
        <td>{{item.promo_price}}</td>

       
      </tr> 
      
      
    </tbody>
    
  </table>
 </div>



<label for="filter">
  <i class="fas fa-filter mr-2 mt-3" aria-hidden="true"></i>
  <strong>Filtra</strong></label>
  <input class="form-control" type="text" name="query" v-model="filterKey">
<div class="mt-2">




</div>

<form class="form-inline float-right" v-on:submit.prevent="setConfirmBox()">
  
  <button type="submit" :disabled="bt_spinner == true"  class="btn btn-primary mr-3 mb-3">
    <i class="far fa-edit  mr-2" aria-hidden="true"></i>
   APPLICA PROMO 
    <span v-if="bt_spinner" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
   </button>


</form>

    <confirm-box v-if="cb.show">     
      <template v-slot:header>
        <strong>{{cb.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cb.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cb.show=false" type="button" class="btn btn-primary float-right">
          OK</button>
      </template>    
    </confirm-box>


     <confirm-box v-if="cbReset.show">     
      <template v-slot:header>
        <strong>{{cbReset.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cbReset.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cbReset.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="houseKeeping()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>    

    <confirm-box v-if="cbConfirm.show">     
      <template v-slot:header>
        <strong>{{cbConfirm.title}}</strong>    
      </template>
      <template v-slot:body1>
        <h4>{{cbConfirm.msg1}}</h4>   
      </template>
      <template v-slot:footer>  
        <button @click="cbConfirm.show=false" type="button" class="btn btn-secondary">
          
          NO</button>
        <button @click="saveData()" type="button" data-dismiss="modal" class="btn btn-primary">SI</button>
      </template>    
    </confirm-box>    




</div>
</template>
<script>

import api                    from "@/api";
import alertBox               from '@/components/common/AlertBox.vue'
import confirmBox             from '@/components/common/ConfirmBox.vue'
import fmt                    from '@/components/mixins/fmt.js'

import {mapGetters }    from 'vuex';

export default {
  props      : ['promoId','products','file_typeId'],
  mixins :[fmt],

  components  : {
    alertBox,  confirmBox,  
    
},
  data() {
    return {
    
      items             : [],
      typeId            : 0,
    
      msg                    : {
        title : '',
        body  : '',
        type  : 0
      },

    

    bt_spinner             : false, 
    
    filterKey              : '' ,
    cb                     : {title : '',msg1 : '',show:false},
    cbReset                : {title : '',msg1 : '',show:false},
    cbConfirm              : {title : '',msg1 : '',show:false},
    
    
     
    }
  },
  computed :{
   
     ...mapGetters(['company']),
     
     filteredItems : function () 
      {
        var filterKey = this.filterKey && this.filterKey.toLowerCase()
        var items = this.items
        if (filterKey) {
        items = items.filter(function (row) {
          return Object.keys(row).some(function (key) {
            return String(row[key]).toLowerCase().indexOf(filterKey) > -1
          })
        })
      }
        return items
     },
     
  },
  directives: {
    focus: {
      // directive definition
      inserted: function(el) {
        el.focus();
      }
    }
  },

  created: function() 
  {
    this.items = this.products
    this.typeId = this.file_typeId
    
  },
  methods: {
    

    setConfirmBox()
    {
      
      if(this.typeId == 2)
      {
        this.cbConfirm.title = 'CONFERMI PROMO SCONTO ?'
      }
      else
      {
        this.cbConfirm.title = 'CONFERMI PROMO PREZZO  ?'
      }

      this.cbConfirm.show = true
    },
    deleteCB()
    {
      if(this.items.length>0)
      {
        this.cbReset.title = 'ELIMINA SELEZIONE PRODOTTI'
        this.cbReset.msg1 = 'Si desidera eliminare la selezione prodotti ?'
        this.cbReset.show = true
        
      }
    },
    houseKeeping()
    {
      this.items=[],
      this.cbReset.show=false,
      this.$emit('reset')
      this.$emit('close')
    },

    
    

    setSelection(set)
    {
        this.items.forEach(item=>{
          item.selected = set
      })
    },

    async saveData() {
    
      this.cbConfirm.show = false
      this.cb.title = ''
      this.bt_spinner = true
      
      let data = {}
      data.body = []
      let colorIds = []
      this.items.forEach(item=>{
        /*
        if(item.selected == 1)
        { 
        */         
          colorIds = item.colorIds.split('|')                    
          colorIds.forEach(colorId => {                      
            data.body.push({'productId':item.productId,'promoId':this.promoId,'discount':item.promo_discount,'colorId':colorId,'price':item.promo_price})  
          })
          
        /*}*/

      })  
      
      const sp = {'sp':'spUpdatePromoProduct'}      
      const json    = Object.assign(data, sp)

         await api.post(json).then(res => {
                    
          if(res.status==200)
            {              
              this.cb.title = "PROMO PRODOTTI"
              this.cb.msg1  = "Registrazione effettuata."
              this.cb.show  = true
                  
            }
          
          else
          {
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
          }
      }).catch(err=>{
        
            
            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1      

      })
      
      this.bt_spinner = false
      
    }

  }
};
</script>
<style scoped>

.my-custom-scrollbar {
position: relative;
height: 400px;
overflow: auto;
}



.pointer:hover
{
  _background-color   : darkorchid;
  _color              : white;
  cursor             : pointer;
}



.table-wrapper-scroll-y {
display: block;
}


.table thead tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }


 .table tfoot  tr:nth-child(1) td
 {

    font-family  : 'Roboto Condensed';
    font-weight  : bold;
    font-size    : 18px;
    background   : whitesmoke;
    color        : green;   
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

h4 {
  font-family: 'Roboto Condensed';
  font-size: 20px;
}
tr {
  font-family: 'Roboto Condensed';
}


</style>